import SelectLink from '~/components/SelectLink/SelectLink';

export default SelectLink;
